// extracted by mini-css-extract-plugin
module.exports = {"col-2":"CreditCardInput_col-2__c7UXp"};